export const WORKFLOW_LINK_CORNERS = [
  "top-left",
  "top-right",
  "bottom-left",
  "bottom-right",
] as const;
export type WorkflowLinkCorner = (typeof WORKFLOW_LINK_CORNERS)[number];

export function workflowLinkCorner(value: string | null): WorkflowLinkCorner {
  return (WORKFLOW_LINK_CORNERS as readonly string[]).includes(value ?? "")
    ? (value as WorkflowLinkCorner)
    : "bottom-right";
}
